import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import JamezzTableV2, { useReloadState } from "../../../../../components/JamezzTable/V2/JamezzTableV2";
import useJTFilter from "../../../../../components/JamezzTable/V2/useJTFilter";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper";
import { Grid, TableCell } from "@mui/material";
import Button from "../../../../../components/CustomButtons/Button";
import { Refresh } from "@mui/icons-material";
import { useFormContext } from "react-hook-form";
import { formatTime } from "../../../../../licensing/utils/formatDate";
import PosSyncLogs from "./PosSyncLogs";

const endPoint = "core/posSyncs";

function PosSyncsIndex(props) {
  const { reloadState, updateReloadState } = useReloadState();
  const [textField, searchFilter] = useJTFilter("type");
  const { vestigingId } = useFormContext();
  const [posSync, setPosSync] = useState(null);
  const shouldSelectFirstPosSync = useRef(true);

  const renderHeaderCells = useCallback(
    () => [
      { id: "id", label: "#", numeric: true, disablePadding: false, sortable: true },

      {
        id: "status",
        label: <TranslationWrapper tDefault={"status"} tKey={"posSyncs.status"} />,
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
      {
        id: "type",
        label: <TranslationWrapper tDefault={"type"} tKey={"posSyncs.type"} />,
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
      {
        id: "user",
        label: <TranslationWrapper tDefault={"By user"} tKey={"posSyncs.user"} />,
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
      {
        id: "created_at",
        label: <TranslationWrapper tDefault={"Created at"} tKey={"posSyncs.created_at"} />,
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
      {
        id: "updated_at",
        label: <TranslationWrapper tDefault={"Last status change"} tKey={"posSyncs.updated_at"} />,
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
    ],
    []
  );

  const renderRowCells = useCallback((row, isEditable) => {
    return (
      <>
        <TableCell align={"right"} style={{ width: 100 }}>
          {row.id}
        </TableCell>
        <TableCell>{row.status}</TableCell>
        <TableCell>{row.type}</TableCell>
        <TableCell>{row.user?.email}</TableCell>
        <TableCell>{formatTime(new Date(row.created_at))}</TableCell>
        <TableCell>{formatTime(new Date(row.updated_at))}</TableCell>
      </>
    );
  }, []);

  const renderRowActions = useCallback((row) => {
    return (
      <TableCell align={"right"}>
        <Button
          color={"primary"}
          onClick={() => {
            shouldSelectFirstPosSync.current = false;
            setPosSync(row);
          }}
          size={"sm"}
        >
          <TranslationWrapper tDefault={"View details"} tKey={"posSyncs.View logs"} />
        </Button>
        {/*<Link to={`./${row.id}/edit`}>*/}
        {/*  <Tooltip title={<TranslationWrapper tKey={"global.jamezzTable.edit"} tDefault={"Edit"} />} placement="bottom">*/}
        {/*    <IconButton size={"small"} color={"primary"} simple>*/}
        {/*      <Edit />*/}
        {/*    </IconButton>*/}
        {/*  </Tooltip>*/}
        {/*</Link>*/}
      </TableCell>
    );
  }, []);

  const filters = useMemo(() => {
    return { vestiging_id: { field: "vestiging_id", value: vestigingId, operator: "=" }, ...searchFilter };
  }, [searchFilter, props.filters, vestigingId]);

  useEffect(() => {
    const updateInterval = setInterval(() => {
      updateReloadState();
    }, 5000);
    return () => {
      clearInterval(updateInterval);
    };
  }, []);

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          {posSync ? <PosSyncLogs key={posSync.id} posSync={posSync} /> : null}
        </Grid>
        {textField}
        <Grid item xs={12}>
          <JamezzTableV2
            checkboxSelection={false}
            dense={true}
            endPoint={endPoint}
            filters={filters}
            headerIcon={<Refresh />}
            onGetData={(data) => {
              if (shouldSelectFirstPosSync.current && (!posSync || data[0]?.id !== posSync.id) && data[0]) {
                setPosSync(data[0]);
              }
            }}
            reloadState={reloadState}
            renderCellsForRow={renderRowCells}
            renderHeaderCells={renderHeaderCells}
            renderRowActions={renderRowActions}
            tableTitle={<TranslationWrapper tDefault={"Pos Syncs"} tKey={"posSyncs.table.title"} />}
            uuid={"PosSyncs-qwioeujncvl"}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default PosSyncsIndex;
